import { Alert, AlertDescription } from "components/ui/alert";
import { Badge } from "components/ui/badge";
import { Card, CardContent } from "components/ui/card";
import { cn } from "@/lib/utils";
import { LocateFixed, Map } from "lucide-react";
import { Fragment } from "react";

interface BatchJobTypeCardProps {
  name: string;
  subtitle: string;
  mandatoryFields: string[];
  selected: boolean;
  onClickHandler: () => void;
  messages?: string[];
}

export const BatchJobTypeCard = (props: BatchJobTypeCardProps) => {
  const iconMapping: Record<string, React.ReactNode> = {
    Geocoder: <LocateFixed className="size-12" />,
    "Reverse Geocoder": <Map className="size-12" />,
  };

  const messageMapping: Record<string, string[]> = {
    Geocoder: ["Supports full and parsed addresses"],
    "Reverse Geocoder": [],
  };

  const subtitleMapping: Record<string, string> = {
    Geocoder: "Address Validation | Geocoding | Address Parsing",
    "Reverse Geocoder": "Turn latitude and longitude into an address label",
  };

  const mandatoryFieldsMapping: Record<string, string[]> = {
    Geocoder: ["Address", "Street Name", "Locality Name"],
    "Reverse Geocoder": ["Latitude", "Longitude"],
  };

  return (
    <button
      type="button"
      onClick={props.onClickHandler}
      className="w-full text-left"
    >
      <Card
        className={cn(
          "w-full h-full",
          props.selected && "ring-2 ring-primary",
        )}
      >
        <CardContent className="flex flex-col gap-4">
          <div className="flex">
            {iconMapping[props.name]}
            <div className="ml-4">
              <h3 className="text-base font-medium">{props.name}</h3>
              <p className="text-sm text-muted-foreground">
                {subtitleMapping[props.name]}
              </p>
            </div>
          </div>
          <p className="text-sm flex items-center flex-wrap gap-1">
            Mandatory Input:{" "}
            {mandatoryFieldsMapping[props.name].map(
              (label: string, index: number) => (
                <Fragment key={label}>
                  <Badge variant="outline">{label}</Badge>
                  {index != mandatoryFieldsMapping[props.name].length - 1 &&
                    (props.name === "Reverse Geocoder" ? " and " : " or ")}
                </Fragment>
              ),
            )}
          </p>
          {messageMapping[props.name] &&
            messageMapping[props.name].map((message: string) => (
              <Alert variant="info" key={message}>
                <AlertDescription>{message}</AlertDescription>
              </Alert>
            ))}
        </CardContent>
      </Card>
    </button>
  );
};
